export enum ACTIONS {
  SET_GUESTS,
  REMOVE_GUEST,
  CLEAR,
}

export type Action =
  | { type: ACTIONS.SET_GUESTS; payload: GuestInformations[] }
  | { type: ACTIONS.REMOVE_GUEST; payload: string }
  | { type: ACTIONS.CLEAR };

export interface GuestInformations {
  id: string;
  firstname?: string;
  lastname?: string;
  gender?: string;
  hesCode?: string;
  birthdate: string;
  itemId?: string;
  trin?: string;
  phone?: string;
}

export interface CommonState {
  guests: GuestInformations[];
}
